export function rqthDocumentForm({file,candidateId,startDate,endDate,unlimited}) {
 if(!file)throw new Error("Ajoutez le justificatif RQTH.");
 if(!/\.(pdf|png|jpe?g)$/i.test(file.name) || file.size>5*1024*1024)throw new Error("Justificatif RQTH : PDF, PNG ou JPEG, 5 Mo maximum.");
 if(!startDate || (!unlimited && !endDate))throw new Error("Renseignez les dates de validité de la RQTH.");
 if(!unlimited && endDate<startDate)throw new Error("La fin de validité RQTH doit être postérieure au début.");
 const form=new FormData();form.append("file",file);form.append("candidateId",candidateId || "");form.append("name",file.name);form.append("type","Travailleur handicapé ( RQTH )");form.append("startDate",`${startDate}T12:00:00`);
 if(!unlimited){form.append("endDate",`${endDate}T12:00:00`);form.append("expirationDate",`${endDate}T12:00:00`);}
 return form;
}
